import Profile from "../Profile/Profile";

const DesktopProfile = ({ currentUser, onLogout, onAvatarUpdate, onPhoneUpdate, onNavigate }) => (
  <div className="d-page">
    <div className="d-container-sm" style={{ maxWidth: 600 }}>
      <Profile
        currentUser={currentUser}
        onLogout={onLogout}
        onAvatarUpdate={onAvatarUpdate}
        onPhoneUpdate={onPhoneUpdate}
        onNavigate={onNavigate}
      />
    </div>
  </div>
);

export default DesktopProfile;
